import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { FetchShipment, logisticsActionCreators, LogisticsActionKeys } from '..';
import { uiActionCreators } from '../../ui';
import * as api from '../logisticsApi';

function* fetchShipmentSaga(action: FetchShipment) {
  yield put(uiActionCreators.showFullPageLoading());
  const shipment = yield* call(api.fetchShipment, action.payload);

  yield put(uiActionCreators.hideFullPageLoading());
  if (shipment) {
    yield put(logisticsActionCreators.setShipment(shipment));
  }
}

export function* watchFetchShipment() {
  yield takeEvery(LogisticsActionKeys.FETCH_SHIPMENT, fetchShipmentSaga);
}
